<template>
  <v-container class="page-container">
    <v-container class="non-table-container">
      <h1 class="text-center mt-10 mb-4">{{ $t("list_registred_products") }}</h1>

      <div class="text-end mb-4">
        <v-btn
          class="btn orange"
          to="/farm/flower_detail"
          target="blank"
        >{{ $t("add_product") }}</v-btn>
      </div>
    </v-container>

    <div class="ma-3">
      <v-tabs
        v-model="tab"
        color="#007e57"
        centered
        grow
      >
        <v-tab href="#tab-1">{{ $t("not_working") }}</v-tab>
        <v-tab href="#tab-2">{{ $t("working") }}</v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item value="tab-1">
        <span v-if="workingFlowers.length === 0">{{ $t("no_not_working_flowers") }}</span>
        <Table v-else :headers="headers" :items="notWorkingFlowers" :hideDefaultHeader="true"
                      :on-click="editHandler" :hiddenLabel="true"
                      showCheckBox :on-checked="onChecked" :clear-selected="clearSelected" />
        </v-tab-item>
        <v-tab-item value="tab-2">
          <Table :headers="headers" :items="workingFlowers" :hideDefaultHeader="true"
                      :on-click="editHandler" :hiddenLabel="true"
                      showCheckBox :on-checked="onChecked" :clear-selected="clearSelected" />
        </v-tab-item>
      </v-tabs-items>
    </div>

    <div v-if="selectedItems.length > 0" class="confirm-area">
      <v-btn class="flex-grow-1 mx-2" color="#00796B" outlined @click="isWorkingHandler(false)">非表示にする</v-btn>
      <v-btn
        class="flex-grow-1 mx-2 white--text"
        color="#00796B"
        depressed
        @click="isWorkingHandler(true)"
      >表示する</v-btn>
    </div>
  </v-container>
</template>

<script>
import Table from "@/components/shared/Table.vue";

export default {
  components: { Table },
  data() {
    return {
      headers: [
        "genus_name",
        "flower_specie"
      ].map(x => ({ text: this.$t(x), value: x, width: "120px" })),
      items: [],
      selectedItems: [],
      clearSelected: false,
      tab: "tab-2"
    };
  },
  created() {
    this.$store.dispatch("flowers/getFlowers").then(this.createTableData);
  },
  methods: {
    async createTableData() {
      const { flowers } = this.$store.state;

      this.items = [];

      flowers.listArr.forEach(id => {
        const f = flowers.list[id];
        this.items.push({
          id: f.id,
          genus_name: f.flower_specie.flower_genus.name,
          flower_specie: f.flower_specie.name,
          flower_type: f.flower_type,
          is_working: f.is_working
        });
      });

      this.clearSelected = false;
    },
    editHandler(e) {
      this.$router.push(`/farm/flower_detail/${e.id}`);
    },
    async isWorkingHandler(is_working) {
      await this.$store.dispatch("flowers/putFlowerIsWorking", {
        ids: this.selectedItems,
        is_working
      });

      this.clearSelected = true;
      this.selectedItems = [];
      this.$store.dispatch("flowers/getFlowers").then(this.createTableData);
    },
    onChecked(e) {
      if (e.item) {
        const { id } = e.item;
        if (e.value) {
          this.selectedItems.push(id);
        } else {
          this.selectedItems = this.selectedItems.filter(x => x !== id);
        }
      } else if (e.items) {
        e.items.forEach(item => {
          if (e.value) {
            this.selectedItems.push(item.id);
          } else {
            this.selectedItems = this.selectedItems.filter(
              id => id !== item.id
            );
          }
        });
      }
    }
  },

  computed: {
    workingFlowers() {
      return this.items.filter(item => item.is_working === true);
    },
    notWorkingFlowers() {
      return this.items.filter(item => item.is_working === false);
    }
  }
};
</script>

<style scoped>
.confirm-area {
  position: fixed;
  width: 90%;
  bottom: 80px;
  background-color: rgba(255, 255, 255, 0.9);
  display: flex;
  margin: 24px 0;
}
</style>
